import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Lottie from "lottie-react";
import rocket from "../../../assets/rocketAnimation.json";
import clouds from "../../../assets/cloudAnimation.json";
import { ReactComponent as PartyPopperIcon } from "../../../assets/PartyPopperIcon.svg";
import { ButtonZoom } from "../utils/ButtonZoom";

const useStyle = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  overviewSection: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "45.625rem",
    alignSelf: "center",
    marginBottom: "3rem",
  },
  overviewCard: {
    display: "flex",
    color: "#FFFFFF",
    backgroundImage: "linear-gradient(to right, #8C1D40, #802642)",
    borderRadius: "0.625rem",
    boxShadow: "0px 0.2rem 1.25rem #00000015",
  },
  rocketAnimation: {
    position: "absolute",
    top: "-15px",
    width: "330px",
    height: "308px",
    right: "0px",
  },
  cloudAnimation: {
    position: "absolute",
    bottom: "0px",
    width: "330px",
    height: "308px",
    right: "0px",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
  },
  welcomeMessage: {
    marginLeft: "1rem",
    fontWeight: "bold",
  },
  subHeading: {
    letterSpacing: 1.6,
  },
}));

interface RenderData {
  backgroundColor: string;
  subheading: string;
  heading: string;
  content: string;
  buttonText: string;
  welcomeMsg: string;
  onClick: () => void;
}

interface HeaderProps {
  userName: string;
  renderData: RenderData;
  hideCard?: boolean;
}

export const HomeHeader = (props: HeaderProps) => {
  const { hideCard = false } = props;
  const classes = useStyle();
  const cardData = props.renderData;
  let userName = props.userName;
  userName = userName.charAt(0).toUpperCase() + userName.slice(1);
  return (
    <Box className={classes.cardContainer} sx={{ position: "relative" }}>
      <Box
        sx={{
          height: "48px",
          display: "flex",
          alignItems: "center",
        }}>
        <PartyPopperIcon style={{ width: 48, height: 48 }} />
        <Typography
          variant="h3"
          component="h2"
          className={classes.welcomeMessage}
          data-sentry-mask
          sx={{ color: "#191919" }}>
          {cardData.welcomeMsg.replace("userName", userName.split(" ")[0])}
        </Typography>
      </Box>
      {!hideCard && (
        <Box sx={{ position: "relative", borderRadius: "15px", marginTop: "2rem" }}>
          <Card
            tabIndex={0}
            sx={{
              minWidth: "280px",
              border: "none",
              backgroundColor: cardData.backgroundColor,
              color: "#ffffff",
              padding: "2rem 2rem 2rem 2rem",
              overflow: "hidden",
            }}>
            <Box sx={{ maxWidth: "calc(100% - 220px)" }}>
              <Typography
                sx={{ mb: 1.5 }}
                gutterBottom
                variant="body1"
                className={classes.subHeading}>
                {cardData.subheading}
              </Typography>
              <Typography sx={{ mb: 1.5 }} variant="h1" component="div">
                {cardData.heading}
              </Typography>
              <Typography sx={{ textAlign: "left" }} variant="body1">
                {cardData.content}
              </Typography>
            </Box>
            <CardActions
              sx={{
                height: "70px",
                padding: "32px 0px 0px 0px",
                margin: "12px 0px 12px 0px",
              }}>
              <ButtonZoom
                size="large"
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                onClick={cardData.onClick}>
                {cardData.buttonText}
              </ButtonZoom>
            </CardActions>
            <Lottie
              className={classes.cloudAnimation}
              animationData={clouds}
              loop={true}
            />
          </Card>
          <Lottie
            className={classes.rocketAnimation}
            animationData={rocket}
            loop={true}
          />
        </Box>
      )}
    </Box>
  );
};
